import { roles } from '@nxsys/store/constants';
import { PayrollCountryType } from '@nxsys/types/models/Common';
import EmploymentIntermediaryReport from '../../../modules/reports/management/listing/EmploymentIntermediaryReport';
import AWRReport from '../../../modules/reports/employee/listing/AWRReport/AWRReport';
import WTRReport from '../../../modules/reports/employee/listing/WTRReport';

/**
 * `agency-reports` stays in the umbrella×Ireland sidebar (48-hour WTR still
 * applies there) but AWR / Employment Intermediary have no Ireland
 * equivalent (ticket: "No AWR"). Filtering here — not just in the sidebar
 * menu — keeps the routes closed to a direct URL, since `agency-reports` is
 * looked up as a single route-module id (AppRoutes/index.tsx) and would
 * otherwise register all three paths regardless of the filtered menu.
 */
export const agencyReportsConfig = (payrollCountry: PayrollCountryType) => {
  const routes = [
    {
      permittedRole: [roles.agency],
      path: '/reports/agency/employment-intermediary',
      element: <EmploymentIntermediaryReport />,
    },
    {
      permittedRole: [roles.agency],
      path: '/reports/agency/awr',
      element: <AWRReport />,
    },
    {
      permittedRole: [roles.agency],
      path: '/reports/agency/wtr',
      element: <WTRReport />,
    },
  ];
  if (payrollCountry === 'IRELAND') {
    return routes.filter((route) => route.path === '/reports/agency/wtr');
  }
  return routes;
};
